// extracted by mini-css-extract-plugin
export default {"departments":"IF-z","departmentHeading":"JF-z","departmentSection":"KF-z","departmentName":"LF-z","departmentLink":"MF-z","expandIcon":"NF-z"};